module.exports = __webpack_public_path__ + "assets/447f03d6101549fcec493783b6daa58c.svg";